import { useApolloClient, useMutation } from "@apollo/client";
import { Modal, Spinner } from "@aqar-app/react-ui";
import config from "../../../../common/config";
import { events } from "@/lib/tracking/constants";
import { formatListing, trackGA4Event } from "@/lib/tracking/gaHelpers";
import css from "./.module.scss";
import { Icon } from "@/components/icon";
import {
  trackGenericCTAClickEvent,
  trackShareItem,
} from "@/lib/tracking/trackNavigationEvents";
import Toast from "@/components/toast/toast";
import { usePath } from "@/contexts/path/path";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { GENERATE_SHARE_LINK } from "@/graphql/queries/user";

const utm_source =
  "?utm_medium=share&utm_campaign=share-listing&utm_source=aqar-web-share";

function NewShareModal({
  type,
  category,
  listing,
  propertyCategory,
  listingType,
}) {
  const { user, token } = useAuthState();
  const apolloClient = useApolloClient();

  const [generateShareLink, { loading }] = useMutation(GENERATE_SHARE_LINK, {
    context: { token },
  });
  const appearance =
    "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400";

  const pushShareListingEvent = (method) => {
    const event = {
      event: events.SHARE_LISTING,
      share_method: method,
      ...formatListing(listing, apolloClient),
    };
    trackGA4Event(event);
  };

  async function getLink({ type, id } = {}) {
    const { data } = await generateShareLink({
      variables: {
        type,
        id,
      },
    });
    return data.User.generateShareLink;
  }

  return (
    <Modal.ClassicOverlay className={`${css.modal} ${css.share}`}>
      <div className={css.title}>
        <Modal.CloseButton />
        <p>شارك الإعلان</p>
      </div>

      <div className={css.body}>
        {loading ? (
          <div className={css.spinner}>
            <Spinner />{" "}
          </div>
        ) : null}

        <button
          type="button"
          onClick={async () => {
            let url = `${config.AQAR_WEB}/ad/${listing?.id}${utm_source}`;

            if (user) {
              url = await getLink({
                type,
                id: listing.id,
              });
            }

            trackShareItem(
              "X",
              category?.ga_listing_type || listingType,
              category?.ga_property_category || propertyCategory,
            );
            window.open(
              `https://twitter.com/share?url=${encodeURIComponent(url)}`,
              "_blank",
              appearance,
            );
          }}
        >
          <Icon width={25} height={25} name="twitter-new-2" />
          <strong>X</strong>
        </button>
        <button
          type="button"
          onClick={async () => {
            let url = `${config.AQAR_WEB}/ad/${listing?.id}${utm_source}`;

            if (user) {
              url = await getLink({
                type,
                id: listing.id,
              });
            }

            trackShareItem(
              "whatsapp",
              category?.ga_listing_type || listingType,
              category?.ga_property_category || propertyCategory,
            );
            window.open(
              `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
              "_blank",
              appearance,
            );
          }}
        >
          <Icon width={25} height={25} name="whatsapp-colored" />
          <strong>واتساب</strong>
        </button>
        <button
          type="button"
          onClick={async (e) => {
            if (!navigator.clipboard) return;

            let url = `${config.AQAR_WEB}/ad/${listing?.id}${utm_source}`;

            if (user) {
              url = await getLink({
                type,
                id: listing.id,
              });
            }
            trackShareItem(
              "copy",
              category?.ga_listing_type || listingType,
              category?.ga_property_category || propertyCategory,
            );
            navigator.clipboard.writeText(url);
            pushShareListingEvent("link");
            Toast("تم نسخ الرابط بنجاح", {
              elm: e.target,
              cls: "success",
            });
          }}
        >
          <Icon width={25} height={25} name="CopyLink-square" />
          <strong>نسخ الرابط</strong>
        </button>
      </div>
    </Modal.ClassicOverlay>
  );
}
function ShareButton({ listing, type, propertyCategory, listingType }) {
  const apolloClient = useApolloClient();
  const { category } = usePath();
  const pushOpenShareListingPopupEvent = () => {
    const event = {
      event: events.OPEN_SHARE_LISTING_MODAL,
      ...formatListing(listing, apolloClient),
    };
    trackGA4Event(event);
  };

  const OpenShareModal = (e) => {
    trackGenericCTAClickEvent(e, {
      listing_type: category?.ga_listing_type || listingType,
      property_category: category?.ga_property_category || propertyCategory,
    });
    pushOpenShareListingPopupEvent();
    return Modal.open(
      <NewShareModal
        type={type}
        category={category}
        listing={listing}
        propertyCategory={propertyCategory}
        listingType={listingType}
      />,
    )(e);
  };

  return (
    <button onClick={OpenShareModal} type="button" data-event-target="share">
      <Icon width={20} height={20} name="Share-colored" />
      مشاركة
    </button>
  );
}
export default ShareButton;
